import React from 'react';
import styled from 'styled-components';
import engText from '../language/Eng_eng.json';

const NavContainer = styled.nav`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 40px;
  position: fixed;
  top: 0;
  width: 100%;
  box-sizing: border-box;
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  z-index: 1000;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  font-family: 'Inter', system-ui, sans-serif;
  transition: all 0.3s ease;

  @media (max-width: 768px) {
    display: none;
  }
`;

const MenuLinks = styled.div`
  display: flex;
  gap: 40px;

  a {
    text-decoration: none;
    color: #1a1a1a;
    font-size: 13px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 1.5px;
    position: relative;
    transition: color 0.3s ease;

    &::after {
      content: '';
      position: absolute;
      width: 0%;
      height: 1px;
      bottom: -4px;
      left: 0;
      background-color: #c9a779;
      transition: width 0.3s ease;
    }

    &:hover {
      color: #c9a779;
    }

    &:hover::after {
      width: 100%;
    }
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const TopMenu: React.FC = () => {
  const { top_menu } = engText;

  return (
    <NavContainer>
      <MenuLinks>
        <a href="#home">{top_menu.home}</a>
        <a href="#drink-eat">{top_menu.drink_eat}</a>
        <a href="#events-venues">{top_menu.events_venues}</a>
        <a href="#contact">{top_menu.contact}</a>
      </MenuLinks>
    </NavContainer>
  );
};

export default TopMenu;
